import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setFeedbackStatus } from '@/redux/feedback/feedbackSlice';

import feedbackService from '@/services/feedbackService';

const requestFeeback = data => async dispatch => {
  try {
    await feedbackService.requestFeeback(data);

    dispatch(setFeedbackStatus('success'));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request RequestFeeback failure',
    );
  }
};

export default {
  requestFeeback,
};
